import { Container, Row, Col, Card } from "react-bootstrap";
import React from "react";
import { Link } from "react-router-dom";

// Featured hero layout for the library: one large card on the left, two stacked
// on the right, then a row of three below. Data comes from Supabase (CMS) now —
// pass in an array of published articles ({slug,title,summary,hero_image_url}).

const truncateText = (text, maxLength) =>
  text && text.length > maxLength ? `${text.substring(0, maxLength)}...` : text || "";

const ArticleCard = ({ article, isRightSide }) => (
  <Link
    to={`/learn/post/${article.slug}`}
    style={{ textDecoration: "none", color: "inherit" }}
  >
    <Card
      style={{
        ...(isRightSide ? { maxHeight: "300px", marginBottom: "20px" } : {}),
        border: "none",
        borderRadius: "15px",
        marginBottom: "50px",
        padding: "15px",
      }}
    >
      <Card.Img
        variant="top"
        src={article.hero_image_url || "/img/og-image.jpg"}
        alt={article.title}
        style={
          isRightSide
            ? { height: "200px", objectFit: "cover", borderRadius: "15px" }
            : {
                height: "600px",
                objectFit: "cover",
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",
                borderRadius: "15px",
              }
        }
      />
      <Card.Body>
        <Card.Title>{article.title}</Card.Title>
        <Card.Text>{truncateText(article.summary, 100)}</Card.Text>
      </Card.Body>
    </Card>
  </Link>
);

const Featured = ({ articles = [] }) => {
  if (!articles.length) return null;
  return (
    <Container>
      <Row>
        {/* Left column with one large card */}
        <Col xs={12} md={8}>
          {articles[0] && <ArticleCard article={articles[0]} />}
        </Col>

        {/* Right column split into two rows */}
        <Col xs={12} md={4}>
          {articles.slice(1, 3).map((article) => (
            <Row key={article.slug} style={{ paddingBottom: "25px" }}>
              <Col xs={12}>
                <ArticleCard article={article} isRightSide={true} />
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
      <Row style={{ paddingTop: "25px" }}>
        {articles.slice(3, 6).map((article) => (
          <Col xs={12} md={4} key={article.slug}>
            <ArticleCard article={article} isRightSide={true} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Featured;
